import { ref, set } from 'firebase/database';
import { hashString } from '../../Helpers/hashString';
import { Person } from '../../Models/person';
import { auth, database } from '../firebase';

export const createAPerson: (
    firstName: string,
    lastName: string,
    email: string,
) => Promise<boolean> = async (firstName, lastName, email) => {
    const newPerson: Person = {
        email: email,
        firstName: firstName,
        lastName: lastName,
        wantsToBeSeen: false,
    };

    try {
        const emailHash = hashString(auth.currentUser?.email!);
        await set(ref(database, `people/${emailHash}`), newPerson);
        return true;
    } catch (error) {
        throw error;
    }
};
